import giftVoucherService from "../../../services/gift-voucher-service";
import userService from "../../../services/user-service";

const GENERATE_OTP = "GIFT_VOUCHER_GENERATE_OTP";
const VALIDATE_OTP = "GIFT_VOUCHER_VALIDATE_OTP";

const LOAD_CUSTOMER_GIFT_VOUCHERS = "LOAD_CUSTOMER_GIFT_VOUCHERS";

export function loadCustomerGiftVouchers(mobileNumber, searcTerm = "",) {
  return (dispatch, getState) => {
    return giftVoucherService
      .getCustomerAvailableGiftVouchers(mobileNumber, searcTerm)
      .then((customerGiftVouchers) => {
        dispatch({
          type: LOAD_CUSTOMER_GIFT_VOUCHERS,
          customerGiftVouchers: customerGiftVouchers,
        });
      });
  };
}
export function generateOTP(sendOtpBody, key, token) {
  return (dispatch, getState) => {
    return userService.generateOTP(sendOtpBody, key, token).then((otp) => {
      dispatch({
        type: GENERATE_OTP,
        otpInfo: otp,
      });
    });
  };
}

export function resendOTP(sendOtpBody, key) {
  return (dispatch, getState) => {
    return userService.resendOTP(sendOtpBody, key).then((otp) => {
      dispatch({
        type: GENERATE_OTP,
        otpInfo: otp,
      });
    });
  };
}

export function validateOTP(body, key, token) {
  return (dispatch, getState) => {
    return userService.validateOTP(body, key, token).then((otp) => {
      dispatch({
        type: VALIDATE_OTP,
        validatedOtpInfo: otp,
      });
    });
  };
}

export function loadCustomerGiftVouchersReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_CUSTOMER_GIFT_VOUCHERS: {
      return action.customerGiftVouchers;
    }
    default:
      return state;
  }
}

export function validateOTPReducer(state = {}, action) {
  switch (action.type) {
    case VALIDATE_OTP: {
      return action.validatedOtpInfo;
    }
    default:
      return state;
  }
}

export function generateOTPReducer(state = {}, action) {
  switch (action.type) {
    case GENERATE_OTP: {
      return action.otpInfo;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/GiftVoucherActivation/modules/GiftVoucherActivation.js